import React from "react";
import styles from "./ExternalLogin.module.scss";

const PhoneStep = ({
  backgroundImage,
  title,
  phoneNumber,
  onPhoneChange,
  onContinue,
  isSubmitting,
  errorMessage,
}) => {
  const isValid = /^\d{10}$/.test(phoneNumber);

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.hero}
        style={{ backgroundImage: `url(${backgroundImage})` }}
        role="img"
        aria-label={title}
      />

      <div className={styles.card}>
        <h1 className={styles.heroTitle}>{title}</h1>

        <div className={styles.phoneRow}>
          <span className={styles.countryCode}>
            <span className={styles.flag} role="img" aria-label="India">
              🇮🇳
            </span>
            <span>+91</span>
          </span>
          <input
            className={styles.phoneInput}
            type="tel"
            inputMode="numeric"
            autoFocus
            placeholder="Enter mobile number"
            maxLength={10}
            value={phoneNumber}
            onChange={(e) => {
              const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
              onPhoneChange(digits);
            }}
          />
        </div>
        {errorMessage ? (
          <div className={styles.errorText} role="alert">
            {errorMessage}
          </div>
        ) : null}
      </div>

      <div className={styles.footer}>
        <button
          type="button"
          className={styles.primaryButton}
          disabled={!isValid || isSubmitting}
          onClick={onContinue}
        >
          {isSubmitting ? "Sending OTP..." : "Continue"}
        </button>
      </div>
    </div>
  );
};

export default PhoneStep;
